import { useState, useEffect } from "react";
import {
  Container,
  AuthContainer,
  HeaderComponent,
  Logo,
  MobileMenuButton,
  NavigatorItems,
  NavigatorItemsLink,
  MobileMenuContainer,
  MobileMenuContent,
  MobileNav,
  MobileNavLink,
  MobileAuthSection,
  StyledButton,
  LinkLogin
} from "./styles";
import Image from "next/image";
import { FaBars, FaTimes } from "react-icons/fa";
import Link from "next/link";

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);

  const navLinks = [
    { name: "Funcionalidades", href: "#funcionalidades" },
    { name: "Benefícios", href: "#beneficios" },
    { name: "Depoimentos", href: "#depoimentos" },
    { name: "Preços", href: "#precos" },
    { name: "FAQ", href: "#faq" },
    { name: "Contato", href: "#contato" }
  ];

  return (
    <HeaderComponent isScrolled={isScrolled}>
      <Container>
        <Logo href="#">
          <Image
            src="/images/logo-blue.png"
            alt="Logo DentalMap"
            width={128}
            height={25}
            style={{
              height: "auto",
              width: 128
            }}
          />
        </Logo>
        <NavigatorItems>
          {navLinks.map((link) => (
            <NavigatorItemsLink
              key={link.name}
              href={link.href}
              className="link-underline"
            >
              {link.name}
            </NavigatorItemsLink>
          ))}
        </NavigatorItems>
        <AuthContainer>
          <Link href={"/auth/login"} style={{ textDecoration: "none" }}>
            <LinkLogin>Login</LinkLogin>
          </Link>
          <Link href={"/auth/signup"} style={{ textDecoration: "none" }}>
            <StyledButton className="primary">Teste grátis</StyledButton>
          </Link>
        </AuthContainer>

        <MobileMenuButton onClick={toggleMobileMenu}>
          {mobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </MobileMenuButton>

        {mobileMenuOpen && (
          <MobileMenuContainer>
            <MobileMenuContent>
              <MobileNav>
                {navLinks.map((link) => (
                  <MobileNavLink key={link.name} onClick={toggleMobileMenu}>
                    {link.name}
                  </MobileNavLink>
                ))}
              </MobileNav>

              <MobileAuthSection>
                <Link href={"/auth/login"} style={{ textDecoration: "none" }}>
                  <MobileNavLink>Login</MobileNavLink>
                </Link>
                <Link href={"/auth/signup"} style={{ textDecoration: "none" }}>
                  <StyledButton className="primary">Teste grátis</StyledButton>
                </Link>
              </MobileAuthSection>
            </MobileMenuContent>
          </MobileMenuContainer>
        )}
      </Container>
    </HeaderComponent>
  );
}
